import { gql } from "@apollo/client";

export const GET_USER_DETAILS = gql`
  query UserDetails($userId: Int!) {
    userDetails(userId: $userId) {
      userId
      authId
      firstName
      lastName
      email
      isActive
      isBot
      kind
      createdAt
      deletedAt
      organizations {
        organizationId
        organizationName
        isActive
        organizationLogoUrl
      }
      brands {
        brandId
        brandName
        brandLogoUrl
        organizationId
        organizationName
        brandUserMappingId
        isAccessActive
        roles {
          roleId
          roleName
          roleKey
        }
        features {
          featureId
          featureName
          featureKey
          isMainMenu
          permissions {
            permissionId
            permissionName
            permissionKey
            isInherited
            isCustom
            isAssigned
          }
        }
      }
    }
  }
`;
